export interface CoaFlagInput {
  /** Deposit, withdrawal, or card amount (non-zero means it is a real transaction). */
  amount: number;
  accountCode: string | null | undefined;
  matchStatus: string | null | undefined;
}

/**
 * True when a transaction has a real amount but no COA account assigned AND is
 * not marked Not-Applicable (match_status = 'not_required'). Used to flag rows
 * that still need an account before posting. Explicit "not_required" rows are
 * intentionally account-less, so they are never flagged.
 */
export function isMissingCoa(input: CoaFlagInput): boolean {
  const hasAmount = Math.abs(input.amount) >= 0.01;
  const hasAccount = input.accountCode != null && input.accountCode !== '';
  const isNotApplicable = input.matchStatus === 'not_required';
  return hasAmount && !hasAccount && !isNotApplicable;
}